<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <span slot="current">Publishers & Sources</span>
        <span slot="title">Publishers & Sources</span>
      </AffixHeader>

      <template v-if="$can('create', 'publishers')">
        <i-button type="primary" @click="$router.push('/publishers/new')">
          <FFIcon type="plus" />New Source/Publisher
        </i-button>
        <br />
        <br />
      </template>

      <!-- <Alert type="error">
        <h4>All write operations are disabled on publishers</h4>
        <span slot="desc">
          Create, update and delete operations are disabled on publishers for the time until the end of the review process.
          View and document associations are still accessable.
        </span>
      </Alert>-->

      <Card dis-hover>
        <h3 slot="title">Search</h3>
        <i-form :model="form" :label-width="50" label-position="right">
          <Row>
            <i-col span="24">
              <i-form-item label="Name">
                <i-input v-model="form.name"></i-input>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Type" style="margin-right:6px;">
                <!--
                  <PublisherTyeSelect v-model="form.type"></PublisherTyeSelect>
                -->
                <i-select v-model="form.type">
                  <i-option v-for="item in typeOptions" :value="item" :key="item">{{ item }}</i-option>
                </i-select>
              </i-form-item>
            </i-col>

            <i-col span="12">
              <i-form-item label="Country">
                <CountrySelect v-model="form.iso3" filterable></CountrySelect>
              </i-form-item>
            </i-col>
          </Row>

          <Row type="flex" justify="end" style="margin:12px 0;">
            <i-form-item class="action-buttons">
              <i-button icon="search" @click="search">Search</i-button>
              <i-button icon="close" @click="reset">Reset</i-button>
            </i-form-item>
          </Row>
        </i-form>
      </Card>

      <br />
      <PublishersTable :conditions="conditions"></PublishersTable>
    </i-col>
  </Row>
</template>

<script>
import PublishersTable from "@/publishers/table.vue";
import CountrySelect from "@/components/country_select";
import { getTsQueryValue } from "@/utils/common";

const emptyForm = {
  name: "",
  type: "",
  iso3: "",
};

export default {
  components: { PublishersTable, CountrySelect },

  data() {
    return {
      form: Object.assign({}, emptyForm),
      conditions: {},
      typeOptions: [
        "Civil Society",
        "Clusters and Consortias",
        "Community Leaders",
        "Government",
        "International NGOs",
        "International Organisations",
        "Local Authority",
        "Media",
        "National/Regional Disaster Authority",
        "Non-State Armed Group",
        "Private Sector",
        "Red Cross/Red Crescent Movement",
        "United Nations",
      ],
    };
  },

  methods: {
    search() {
      let conditions = {};

      // Name
      if (this.form.name !== "") {
        conditions["name"] = getTsQueryValue(this.form.name)
      }

      // Type
      if (this.form.type !== "") {
        conditions["type"] = `eq.${this.form.type}`;
      }

      // ISO3
      if (this.form.iso3 !== "") {
        conditions["iso3"] = `eq.${this.form.iso3}`;
      }

      this.conditions = conditions;
    },

    reset() {
      this.form = Object.assign({}, emptyForm);
      this.conditions = {};
    },
  },
};
</script>

<style lang="css"></style>
